"use client"

import Icon from "./Icon"
import { formatMoney } from "../utils/format"

export const GLOBAL_WALLET_MODULES = [
  { key: "frp", label: "Rentals", icon: "building", accent: "text-green-700", chip: "bg-green-50 border-green-100" },
  { key: "groups", label: "Groups", icon: "people", accent: "text-blue-700", chip: "bg-blue-50 border-blue-100" },
  { key: "utbills", label: "Utilities", icon: "droplet-half", accent: "text-teal-700", chip: "bg-teal-50 border-teal-100" },
]

// Dashboard card: accumulated balance of all module wallets with a per-module
// breakdown, plus entry points into the global wallet settings and statement.
function GlobalWalletCard({ balances = {}, onOpenSettings, onOpenTransactions }) {
  const total = GLOBAL_WALLET_MODULES.reduce(
    (sum, m) => sum + Number(balances?.[m.key] || 0),
    0
  )

  return (
    <div className="mb-6 rounded-2xl border border-green-200 bg-white shadow-sm">
      {/* Label + total on the left, icon-only actions on the right.
          Per-module balances now live on each module card in RoleMenu. */}
      <div className="flex items-center justify-between gap-3 rounded-2xl bg-green-50/50 px-4 py-3">
        <div className="min-w-0">
          <span className="flex items-center gap-1.5 text-[10px] font-semibold uppercase tracking-widest text-green-500">
            <Icon name="wallet2" size="0.8rem" />
            Global Wallet
          </span>
          <p className="mt-0.5 text-2xl font-bold leading-none text-slate-900 tabular-nums">
            {formatMoney(total)}
          </p>
        </div>
        <div className="flex shrink-0 items-center gap-1.5">
          <button
            type="button"
            onClick={onOpenTransactions}
            aria-label="Open global wallet statement"
            title="Statement"
            className="flex h-8 w-8 items-center justify-center rounded-lg border border-green-200 bg-white text-green-600 shadow-sm transition-colors hover:bg-green-50"
          >
            <Icon name="list-ul" size="0.85rem" />
          </button>
          <button
            type="button"
            onClick={onOpenSettings}
            aria-label="Open global wallet settings"
            title="Settings"
            className="flex h-8 w-8 items-center justify-center rounded-lg border border-green-200 bg-white text-green-600 shadow-sm transition-colors hover:bg-green-50"
          >
            <Icon name="gear" size="0.85rem" />
          </button>
        </div>
      </div>
    </div>
  )
}

export default GlobalWalletCard
